import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import axiosApiInstance from "app/services/axios";
import { getDataEndPoint, updateDataEndPoint } from "app/utils/constants/paths";
import uuid from "react-uuid";
import { DATASOURCE_CONFIG } from "app/config";
import { addslashes } from "app/utils/utils";
const tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  themesList: [],
  themeDetails: {
    name: "",
    header_options: {},
    sidebar_options: {},
    maincontent_options: {},
    footer_options: {},
  },
};

export const GetAllThemesListThunk = createAsyncThunk(
  "company/GetAllThemesListThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            payload?.search != "" &&
            payload?.search != undefined &&
            payload?.search != null
              ? "select id,name,header_options,sidebar_options,maincontent_options,footer_options,creation_date from " +
                tablePrefix +
                "themes where name " +
                DATASOURCE_CONFIG.QUERY_LIKE +
                " '%" +
                payload.search +
                "%' and status ='1' order by creation_date desc"
              : "select id,name,header_options,sidebar_options,maincontent_options,footer_options,creation_date from " +
                tablePrefix +
                "themes where status ='1' order by priority desc, creation_date desc",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      return response;
    } catch (err) {
      console.log("response", err);
    }
  }
);

export const InsertUpdateThemeDetailsThunk = createAsyncThunk(
  "company/InsertUpdateThemeDetailsThunk",
  async (payload) => {
    //console.log('payload', payload)
    let insertUpdateQuery = "";
    if (payload.action == "add") {
      insertUpdateQuery =
        "insert into " +
        tablePrefix +
        "themes (id,name,header_options,sidebar_options,maincontent_options,footer_options,created_by,creation_date,updated_date) values('" +
        payload.id +
        "','" +
        addslashes(payload.name) +
        "','" +
        JSON.stringify(payload.header_options) +
        "','" +
        JSON.stringify(payload.sidebar_options) +
        "','" +
        JSON.stringify(payload.maincontent_options) +
        "','" +
        JSON.stringify(payload.footer_options) +
        "','" +
        payload.created_by +
        "'," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        "," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        "" +
        ") ";
    } else {
      insertUpdateQuery =
        "update " +
        tablePrefix +
        "themes set name='" +
        addslashes(payload.name) +
        "',header_options='" +
        JSON.stringify(payload.header_options) +
        "',sidebar_options='" +
        JSON.stringify(payload.sidebar_options) +
        "',maincontent_options='" +
        JSON.stringify(payload.maincontent_options) +
        "',footer_options='" +
        JSON.stringify(payload.footer_options) +
        "',updated_date=" +
        DATASOURCE_CONFIG.CURRENT_DATE +
        "" +
        " where id='" +
        payload.id +
        "'";
    }

    console.log("Themes Insert Update Query:", insertUpdateQuery);

    const queryBody = {
      queries: [
        {
          query: insertUpdateQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetThemeDetailsThunk = createAsyncThunk(
  "theme/GetThemeDetailsThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select id,name,header_options,sidebar_options,maincontent_options,footer_options from " +
            tablePrefix +
            "themes where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      return response;
    } catch (err) {
      console.log("response", err);
    }
  }
);

export const UpdateThemeStatusThunk = createAsyncThunk(
  "theme/UpdateThemeStatusThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "update " +
            tablePrefix +
            "themes set status='0' where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const Theme = createSlice({
  name: "theme",
  initialState,
  reducers: {
    resetThemeForm(state, action) {
      state.themeDetails = {
        name: "",
        header_options: {},
        sidebar_options: {},
        maincontent_options: {},
        footer_options: {},
      };
    },
  },

  extraReducers(builder) {
    builder
      .addCase(GetAllThemesListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllThemesListThunk.fulfilled, (state, action) => {
        if (action.payload.data.results[0]) {
          state.themesList = action.payload.data.results[0];
        }

        state.loading = false;
      })
      .addCase(GetAllThemesListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(InsertUpdateThemeDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(InsertUpdateThemeDetailsThunk.fulfilled, (state, action) => {
        if (!action.payload.data?.error) {
          let themeData = {
            name: action.meta.arg.name,
            header_options: action.meta.arg.header_options,
            sidebar_options: action.meta.arg.sidebar_options,
            maincontent_options: action.meta.arg.maincontent_options,
            footer_options: action.meta.arg.footer_options,
          };
          state.accountDetails = themeData;

          //state.accountsDetails = action.payload.data.results[0];
        }
        state.loading = false;
      })
      .addCase(InsertUpdateThemeDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })

      .addCase(GetThemeDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetThemeDetailsThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results[0].length > 0) {
          let resultData = action.payload.data?.results[0][0];
          let themeData = {
            name: resultData.name,
            header_options:
              resultData.header_options != ""
                ? JSON.parse(resultData.header_options)
                : {},
            sidebar_options:
              resultData.sidebar_options != ""
                ? JSON.parse(resultData.sidebar_options)
                : {},
            maincontent_options:
              resultData.maincontent_options != ""
                ? JSON.parse(resultData.maincontent_options)
                : {},
            footer_options:
              resultData.footer_options != ""
                ? JSON.parse(resultData.footer_options)
                : {},
          };
          state.themeDetails = themeData;
        }
        state.loading = false;
      })
      .addCase(GetThemeDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(UpdateThemeStatusThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateThemeStatusThunk.fulfilled, (state, action) => {
        if (action.payload.data?.error == false) {
          let themeList = state.themesList;
          let themeId = action.meta.arg.id;
          themeList = themeList.filter((item) => item.id !== themeId);
          state.themesList = themeList;
        }
        state.loading = false;
      })
      .addCase(UpdateThemeStatusThunk.rejected, (state, action) => {
        state.loading = false;
      });
  },
});
const { actions, reducer } = Theme;
// Extract and export each action creator by name
export const {
  resetThemeForm,
  // showHideSwitchAccountModal,
  // switchToAccount,
  // updateDashboardFilter,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
